import { env } from "@/lib/environment";

/** Default quality when Next.js image optimization is used (non-WebP or local assets). */
export const CDN_IMAGE_QUALITY = 60;

export function isPickcelCdnImage(src: string): boolean {
  return (
    src.includes("cdn.pickcel.com") ||
    Boolean(env.NEXT_PUBLIC_CDN_URL && src.startsWith(env.NEXT_PUBLIC_CDN_URL))
  );
}

/** CDN WebP assets are already compressed — skip the Next.js image proxy for faster loads. */
export function shouldBypassImageOptimizer(src: string): boolean {
  return isPickcelCdnImage(src) && /\.webp(\?|\.|$)/i.test(src);
}

type CdnImageOptions = {
  quality?: number;
  priority?: boolean;
  unoptimized?: boolean;
};

export function getCdnImageProps(src: string, options: CdnImageOptions = {}) {
  const unoptimized = options.unoptimized ?? shouldBypassImageOptimizer(src);

  if (unoptimized) {
    return {
      unoptimized: true as const,
      ...(options.priority
        ? { priority: true, fetchPriority: "high" as const }
        : { loading: "lazy" as const, fetchPriority: "auto" as const }),
    };
  }

  return {
    quality: options.quality ?? CDN_IMAGE_QUALITY,
    ...(options.priority
      ? { priority: true, fetchPriority: "high" as const }
      : { loading: "lazy" as const, fetchPriority: "auto" as const }),
  };
}
